module.exports = __webpack_public_path__ + "static/media/Razorback511_3c.04ab92d4.svg";